@import '../../assets/styles/components.css';

@layer components {
  :host {
    @apply cursor-pointer inline-flex items-center text-neutral-dark gap-x-2;

    abds-icon {
      @apply p-1 text-neutral-lightest;
    }

    .switch-container {
      @apply grid items-center h-6 w-12;
      @apply bg-secondary-200 rounded-full;
      @apply duration-150 ease-out transition;
      @apply focus:outline-none focus:ring focus:ring-primary-200;
      @apply hover:bg-secondary-300;
      @apply active:bg-secondary-400;
    }

    .icons-container {
      @apply inline-flex;
    }

    .icons-container,
    .thumb {
      grid-area: 1 / -1;
    }

    .thumb {
      @apply bg-neutral-lightest h-5 ml-0.5 rounded-full w-5;
      @apply duration-150;
    }

    &([checked]) {
      .switch-container {
        @apply bg-brand;
        @apply hover:bg-brand-600;
        @apply active:bg-brand-700;
      }

      .thumb {
        @apply translate-x-6;
      }
    }

    &([disabled]) {
      @apply pointer-events-none;

      abds-icon {
        @apply text-neutral-light;
      }

      abds-label {
        @apply cursor-default;
      }

      .switch-container {
        @apply bg-secondary-100;
      }

      .thumb {
        @apply bg-neutral-light;
      }
    }
  }
}
